import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';

function EPGCategoryList({ categories, selectedCategory, onCategoryChange }) {
  const containerRef = React.useRef(null);
  const [canScrollLeft, setCanScrollLeft] = React.useState(false);
  const [canScrollRight, setCanScrollRight] = React.useState(false);

  const checkScroll = () => {
    const el = containerRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  React.useEffect(() => {
    checkScroll();
    const el = containerRef.current;
    if (!el) return;

    const handleResize = () => checkScroll();
    const handleScroll = () => checkScroll();

    el.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      el.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const scrollLeft = () => {
    containerRef.current.scrollBy({ left: -150, behavior: 'smooth' });
  };

  const scrollRight = () => {
    containerRef.current.scrollBy({ left: 150, behavior: 'smooth' });
  };

  return (
    <div className="scroll-wrapper">
      {canScrollLeft && (
        <button className="scroll-button" onClick={scrollLeft}>
          <i className="bi bi-chevron-left"></i>
        </button>
      )}
      <div className="scroll-container" ref={containerRef}>
        {categories.map((opt, index) => (
          <div
            key={index}
            className={`scroll-container-item ${selectedCategory === opt ? 'selected' : ''}`}
            onClick={() => onCategoryChange(opt)}
          >
            {opt}
          </div>
        ))}
      </div>
      {canScrollRight && (
        <button className="scroll-button" onClick={scrollRight}>
          <i className="bi bi-chevron-right"></i>
        </button>
      )}
    </div>
  );
}
EPGCategoryList.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedCategory: PropTypes.string,
  onCategoryChange: PropTypes.func.isRequired,
};
EPGCategoryList.defaultProps = {
  selectedCategory: null,
};
export default React.memo(EPGCategoryList);
